var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"float",attrs:{"src":require("@/assets/icons/whatsapp.svg")},on:{"click":function($event){return _vm.openWhatsapp()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }